"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Mastercard = ({ width, height }) => {
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h32v32H0z" }),
            react_1.default.createElement(react_native_svg_1.G, { transform: "translate(.5 4.5)" },
                react_1.default.createElement(react_native_svg_1.Rect, { fill: "#EDEDED", width: "31", height: "23", rx: "3" }),
                react_1.default.createElement(react_native_svg_1.G, { transform: "translate(6.74 6.088)" },
                    react_1.default.createElement(react_native_svg_1.Ellipse, { fill: "#E61C24", cx: "5.391", cy: "5.412", rx: "5.391", ry: "5.412" }),
                    react_1.default.createElement(react_native_svg_1.Ellipse, { fill: "#F99F1B", cx: "12.086", cy: "5.412", rx: "5.391", ry: "5.412" }),
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M8.739 1.174a5.41 5.41 0 0 0-2.044 4.238 5.41 5.41 0 0 0 2.044 4.237 5.41 5.41 0 0 0 2.044-4.237 5.41 5.41 0 0 0-2.044-4.238z", fill: "#F26622" }))))));
};
Mastercard.defaultProps = {
    width: 32,
    height: 32,
};
exports.default = react_1.default.memo(Mastercard);
